import { Toast } from 'antd-mobile';
import {
  luckyDrawMayInfo,
  luckyDrawMayDrawInfoList,
  luckyDrawMayRank,
  luckyDrawMayProgress,
  luckyDrawMayTurnOffDialog,
  luckyDrawMayDraw,
  luckyDrawMayDrawRecord,
  luckyDrawMayVoteInfo,
  luckyDrawMayVoteRecord,
  luckyDrawMayVote,
  luckyDrawMaySearchVoteUser,
  luckyDrawMayFloatScreen,
} from '@/services/activity';

export default {
  namespace: 'luckyDrawMay',
  state: {
    startTime: 0,
    endTime: 0,
    status: 0,
    title: '',
    titleUrl: '',
    rules: '',
    activityType: 1,
    disableDialog: false,
    coinValue: 0,
    resetTime: 0,
    coinRank: [],
    limitedGifts: [],
    drawRewardList: [],
    totalRewards: [],
    anchorRewardList: [],
    unlockRewardList: [],
    remainTimes: 0,
    puzzleImage: '',
    drawRewardInfoList: [],
    exchangeRate: 0,
    unlockCoins: '',
    rankList: [],
    selfInfo: {},
    lastId: '',
    currentEnergy: 0,
    progressList: [],
    pageNum: 1,
    pageSize: 20,
    drawRecordHasMore: false,
    drawRecordList: [],
    giftToTicket: 0,
    currentTicket: 0,
    voteList: [],
    voteTop3RewardsList: [],
    voteRecordHasMore: false,
    voteRecordList: [],
    voteLastId: '',
    existEnergy: false,
    obtainRewardList: [],
    progressReward: {},
  },
  reducers: {
    updateInfo(state, { payload }) {
      return {
        ...state,
        startTime: payload.startTime || 0,
        endTime: payload.endTime || 0,
        status: payload.status || 0,
        title: payload.title || '',
        titleUrl: payload.titleUrl || '',
        rules: payload.rules || '',
        activityType: payload.activityType || 1,
        disableDialog: payload.disableDialog || false,
        coinValue: payload.coinValue || 0,
        resetTime: payload.resetTime || 0,
        coinRank: payload.coinRank || [],
        limitedGifts: payload.limitedGifts || [],
        drawRewardList: payload.drawRewardList || [],
        totalRewards: payload.totalRewards || [],
        anchorRewardList: payload.anchorRewardList || [],
        unlockRewardList: payload.unlockRewardList || [],
      };
    },
    updateDrawInfoList(state, { payload }) {
      return {
        ...state,
        remainTimes: payload.remainTimes || 0,
        puzzleImage: payload.puzzleImage || '',
        drawRewardInfoList: payload.drawRewardInfoList || [],
        exchangeRate: payload.exchangeRate || 0,
        unlockCoins: payload.unlockCoins || '',
      };
    },
    updateRankList(state, { payload }) {
      const { activityRankVO, force } = payload;
      let list = force ? [] : [...state.rankList];
      let selfInfo = {};
      let lastId = '';
      if (activityRankVO.ranks && activityRankVO.ranks.length) {
        list = [...list, ...activityRankVO.ranks];
        lastId = activityRankVO.ranks[activityRankVO.ranks.length - 1].userId;
      }
      if (activityRankVO.selfInfo && activityRankVO.selfInfo.userId) {
        selfInfo = activityRankVO.selfInfo;
      }
      return {
        ...state,
        rankList: list,
        selfInfo: selfInfo,
        lastId: lastId,
      };
    },
    updateProgressList(state, { payload }) {
      return {
        ...state,
        currentEnergy: payload.currentEnergy || 0,
        progressList: payload.drawRewardList || [],
      };
    },
    updateDrawRecord(state, { payload }) {
      let list = payload.force ? [] : [...state.drawRecordList];
      if (payload.record && payload.record.length) {
        list = [...list, ...payload.record];
      }
      return {
        ...state,
        drawRecordList: list || [],
        pageNum: payload.pageNum,
        drawRecordHasMore: payload.record && payload.record.length > 0 ? true : false,
      };
    },
    updateVoteInfo(state, { payload }) {
      return {
        ...state,
        giftToTicket: payload.giftToTicket || 0,
        currentTicket: payload.currentTicket || 0,
        voteList: (payload.activityRankVO && payload.activityRankVO.ranks) || [],
        voteTop3RewardsList: payload.totalRewards || [],
      };
    },
    updateVoteRecord(state, { payload }) {
      const { rankVO, force } = payload;
      let list = force ? [] : [...state.voteRecordList];
      let lastId = '';
      if (rankVO.ranks && rankVO.ranks.length) {
        list = [...list, ...rankVO.ranks];
        lastId = rankVO.ranks[rankVO.ranks.length - 1].userId;
      }
      return {
        ...state,
        voteRecordList: list,
        voteLastId: lastId,
        voteRecordHasMore: lastId ? true : false,
      };
    },
    updateDrawInfo(state, { payload }) {
      return {
        ...state,
        existEnergy: payload.existEnergy || false,
        // puzzleImage: payload.puzzleImage || '',
        obtainRewardList: payload.obtainRewardList || [],
        progressReward: payload.progressReward || {},
      };
    },
    updateVote(state, { payload }) {
      return {
        ...state,
        currentTicket: payload.currentTicket || 0,
      };
    },
    updateDialog(state, { payload }) {
      return {
        ...state,
        disableDialog: payload,
      };
    },
  },
  effects: {
    *getInfo({ payload }, { call, put }) {
      const { error, data } = yield call(luckyDrawMayInfo, payload);
      if (error || !data) {
        yield put({
          type: 'updateInfo',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateInfo',
        payload: data,
      });
      return data;
    },
    *getDrawInfoList({ payload }, { call, put }) {
      const { error, data } = yield call(luckyDrawMayDrawInfoList, payload);
      if (error || !data) {
        yield put({
          type: 'updateDrawInfoList',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateDrawInfoList',
        payload: data,
      });
      return data;
    },
    *getRankList({ payload }, { call, put, select }) {
      const { lastId } = yield select(state => state.luckyDrawMay);
      const { data, error } = yield call(luckyDrawMayRank, { ...payload, lastId: payload.force ? '' : lastId, force: undefined });
      if (error) {
        yield put({
          type: 'updateRankList',
          payload: [],
        });
        return error;
      }
      yield put({
        type: 'updateRankList',
        payload: { ...data, force: payload.force },
      });
      return true;
    },
    *getProgressList({ payload }, { call, put }) {
      const { error, data } = yield call(luckyDrawMayProgress, payload);
      if (error || !data) {
        yield put({
          type: 'updateProgressList',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateProgressList',
        payload: data,
      });
      return data;
    },
    *closeDialog({ payload }, { call, put }) {
      const { error, data } = yield call(luckyDrawMayTurnOffDialog, payload);
      if (error || !data) {
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return {
          success: false,
          error,
          code,
        };
      } else {
        yield put({
          type: 'updateDialog',
          payload: data,
        });
        return {
          data,
          success: true,
        };
      }
    },
    *draw({ payload }, { call, put }) {
      const { error, data } = yield call(luckyDrawMayDraw, payload);
      if (error || !data) {
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return {
          success: false,
          error,
        };
      }
      yield put({
        type: 'updateDrawInfo',
        payload: data,
      });
      return {
        success: true,
        data,
      };
    },
    *getDrawRecord({ payload }, { call, put, select }) {
      const { pageNum, pageSize } = yield select(state => state.luckyDrawMay);
      const { error, data } = yield call(luckyDrawMayDrawRecord, { ...payload, pageNum: payload.force ? 1 : pageNum, pageSize: pageSize, force: undefined });
      if (error || !data) {
        yield put({
          type: 'updateDrawRecord',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateDrawRecord',
        payload: { record: data, pageNum: payload.force ? 2 : pageNum + 1, force: payload.force },
      });
      return true;
    },
    *getVoteInfo({ payload }, { call, put }) {
      const { error, data } = yield call(luckyDrawMayVoteInfo, payload);
      if (error || !data) {
        yield put({
          type: 'updateVoteInfo',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateVoteInfo',
        payload: data,
      });
      return data;
    },
    *getVoteRecord({ payload }, { call, put, select }) {
      const { voteLastId } = yield select(state => state.luckyDrawMay);
      const { data, error } = yield call(luckyDrawMayVoteRecord, { ...payload, lastId: payload.force ? '' : voteLastId, force: undefined });
      if (error) {
        yield put({
          type: 'updateVoteRecord',
          payload: [],
        });
        return error;
      }
      yield put({
        type: 'updateVoteRecord',
        payload: { ...data, force: payload.force },
      });
      return true;
    },
    *vote({ payload }, { call, put }) {
      const { error, data } = yield call(luckyDrawMayVote, payload);
      if (error || !data) {
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return {
          success: false,
          error,
        };
      }
      yield put({
        type: 'updateVote',
        payload: data,
      });
      return {
        success: true,
        data,
      };
    },
    *searchVoteUser({ payload }, { call, put }) {
      const { error, data } = yield call(luckyDrawMaySearchVoteUser, payload);
      if (error || !data) {
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return {
          success: false,
          error,
        };
      }
      return {
        success: true,
        data,
      };
    },
    *getFloatList({ payload }, { call }) {
      const { error, data } = yield call(luckyDrawMayFloatScreen, payload);
      if (error) {
        return {
          error,
          success: false,
        };
      }
      if (data) {
        return {
          success: true,
          data: data,
        };
      } else {
        return false;
      }
    },
  },
};
